import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateMachineGroup } from "@/api/machine-group-api";
import { type MachineGroup } from "@/schemas/machine-group";

import { MACHINE_GROUPS_QUERY_KEY } from "./use-machine-groups";

export const useUpdateMachineGroup = () => {
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationFn: (data: MachineGroup) => updateMachineGroup(data),
		onSuccess: async () => {
			await queryClient.refetchQueries({ queryKey: MACHINE_GROUPS_QUERY_KEY });
		},
	});

	return {
		mutate: mutation.mutateAsync,
		isPending: mutation.isPending,
		isSuccess: mutation.isSuccess,
		isError: mutation.isError,
		error: mutation.error,
	};
};
